import { TOKEN_KEY } from '@/api/index';
import { getNewWorldTokenLocalStorageKey } from '@/helpers/localStorageKeyHelper';
import { CLIENT_ID_HEADER } from '@payaca/shared-isomorphic/constants/clientId';
import { GraphQLClient } from 'graphql-request';

type AuthHeaderProps = {
  authorization?: string;
};

export const gqlClient = new GraphQLClient(import.meta.env.VITE_GRAPHQL_HOST, {
  headers: () => {
    const authHeaders = {} as AuthHeaderProps;

    const token =
      // New world graphql token
      localStorage.getItem(getNewWorldTokenLocalStorageKey()) ||
      // Old world Nest token
      localStorage.getItem(TOKEN_KEY);

    if (token) {
      authHeaders['authorization'] = `Bearer ${token}`;
    }

    return {
      'Content-Type': 'application/json',
      [CLIENT_ID_HEADER]: 'webapp-provider',
      ...authHeaders,
    };
  },
});
